<template>
  <custome-Dialog
    :dialog-visible.sync="dialogVisible"
    :confirm-text="disabledBtn?'上传视频中':'保存'"
    :title="title"
    width="50%"
    :confirm-disable="disabledBtn"
    @confirm="confirm"
    @close="close"
  >
    <div class="content">
      <el-form
        ref="createForm"
        class="header"
        :model="createForm"
        :rules="creatRules"
        label-width="100px"
      >
        <el-form-item
          label="课程内容"
          prop="classContent"
        >
          <el-input
            v-model="createForm.classContent"
          />
        </el-form-item>
        <el-form-item
          label="课程总时长(分)"
          prop="totalMinute"
        >
          <el-input
            v-model="createForm.totalMinute"
          />
        </el-form-item>
        <el-form-item
          label="上传视频"
          prop="videoUrl"
        >
          <div class="video-upload">
            <upload
              :file-list.sync="createForm.recordVideoUrl"
              type="video"
              @isProcess="getProcess"
            />
            <div />
          </div>
        </el-form-item>
      </el-form>
      <div class="chapter-header">
        <div class="label">
          未选章节
        </div>
        <div />
        <div class="label">
          已选章节
        </div>
      </div>
      <div class="chapter">
        <el-scrollbar class="un-selected">
          <div
            v-for="chapter in chapterListFormat.noSelected"
            :key="chapter.id"
            class="item"
          >
            <el-checkbox v-model="chapter.checked">
              {{ chapter.chapterName }}
            </el-checkbox>
          </div>
        </el-scrollbar>
        <div class="control">
          <span
            :class="{'active':toRight}"
            @click="transfer(true)"
          >绑定
            <svg-icon name="arrow-right" />
          </span>
          <span
            :class="{'active': toLeft}"
            @click="transfer(false)"
          >解绑
            <svg-icon name="arrow-left" />
          </span>
        </div>
        <el-scrollbar class="selected">
          <div
            v-for="chapter in chapterListFormat.selected"
            :key="chapter.id"
            class="item"
          >
            <el-checkbox v-model="chapter.checked">
              {{ chapter.chapterName }}
            </el-checkbox>
          </div>
        </el-scrollbar>
      </div>
    </div>
  </custome-Dialog>
</template>
<script>
import customeDialog from '@/components/common/dialog.vue';
import upload from '@/components/common/upload/upload.vue';

export default {
  name: 'ScheduleTplItemDialog',
  components: { customeDialog, upload },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    item: {
      type: [Object],
    },
    chapterList: {
      type: Array,
      default: () => [],
    },
    chapterIds: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      title: '课程章节维护',
      cancelText: '取消',
      disabledBtn: false,
      chapterListFormat: {
        noSelected: [],
        selected: [],
      },
      createForm: {
        classContent: null,
        chapterList: [],
        totalMinute: null,
        recordVideoUrl: '',
      },
      creatRules: {
        classContent: [
          { required: false, message: '请输入内容', trigger: 'blur' },
        ],
        totalMinute: [
          {
            required: false, message: '请输入总时长', trigger: 'blur',
          },
        ],
      },
    };
  },
  computed: {
    toRight() {
      return this.chapterListFormat.noSelected.filter((v) => v.checked).length > 0;
    },
    toLeft() {
      return this.chapterListFormat.selected.filter((v) => v.checked).length > 0;
    },
  },
  watch: {
    dialogVisible() {
      this.getChapterList();
    },
  },
  mounted() {
    console.log(this.item);
  },
  methods: {
    // 上传过程中
    getProcess(value) {
      this.disabledBtn = value;
    },
    // 处理章节
    getChapterList() {
      let arr = [];
      this.chapterListFormat.selected = [];
      this.chapterListFormat.noSelected = [];
      if (!this.chapterList) return;
      this.chapterList.forEach((v) => {
        if (v.sonList) {
          arr = [...arr, ...v.sonList];
        }
      });
      const itemChapterIds = this.item.chapterList.map((chapter) => chapter.id);
      arr.forEach((v) => {
        this.$set(v, 'checked', false);
        if (itemChapterIds.includes(v.id)) {
          this.chapterListFormat.selected.push(v);
        } else if (!this.chapterIds.includes(v.id)) {
          this.chapterListFormat.noSelected.push(v);
        }
      });
      this.createForm.classContent = this.item.classContent;
      this.createForm.totalMinute = this.item.totalMinute;
      this.createForm.recordVideoUrl = this.item.recordVideoUrl;
    },
    // 移动
    transfer(flag) {
      const checkedIds = [];
      if (flag) {
        // 右移
        this.chapterListFormat.noSelected.forEach((v) => {
          if (v.checked) {
            v.checked = false;
            this.chapterListFormat.selected.push(v);
            checkedIds.push(v.id);
          }
        });
        this.chapterListFormat.noSelected = this.chapterListFormat.noSelected.filter((v) => checkedIds.indexOf(v.id) === -1);
      } else {
        // 左移
        this.chapterListFormat.selected.forEach((v, i) => {
          if (v.checked) {
            v.checked = false;
            this.chapterListFormat.noSelected.push(v);
            this.chapterListFormat.selected.splice(i, 1);
            checkedIds.push(v.id);
          }
        });
        this.chapterListFormat.selected = this.chapterListFormat.selected.filter((v) => checkedIds.indexOf(v.id) === -1);
      }
    },
    // 新增一行
    addColumn() {
      const obj = {
        amContent: {
          classContent: '',
          chapterList: [],
          totalMinute: null,
        },
      };
      this.dateList.push(obj);
    },
    close() {
      this.$emit('update:dialogVisible', false);
      this.$emit('close');
    },
    confirm() {
      this.$refs.createForm.validate(async (valid) => {
        if (this.createForm.totalMinute === '') {
          this.createForm.totalMinute = null;
        }
        if (valid) {
          this.createForm.chapterList = this.chapterListFormat.selected;
          this.$emit('update:dialogVisible', false);
          this.$emit('confirm', this.createForm);
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.content {
  min-height: 200px;
  .chapter-header {
    display: flex;
    margin-top: 40px;
    margin-bottom: 10px;
    font-weight: 500;
    font-size: 16px;
    & > div {
      flex: 1;
      justify-content: center;
      text-align: center;
      &.label {
        flex: 2;
      }
    }
  }
  .chapter {
    display: flex;
    justify-content: space-between;
    & > div {
      flex: 2;
      box-sizing: border-box;
      border-radius: 3px;
      height: 300px;
      padding: 16px;
      border: 1px solid rgba($--base-color-grey, $alpha: 0.3);
      &:first-child {
        &::before {
          content: '未选章节';
          display: block;
          font-size: 16px;
          color: rgba($--base-color-black, $alpha: 1);
          position: absolute;
          top: -30px;
        }
      }
    }
    .item {
      margin-bottom: 8px;
    }
    .control {
      flex: 1;
      border: none;
      font-size: 14px;
      display: inline-flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      span {
        width: 80px;
        height: 40px;
        margin-bottom: 16px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        cursor: not-allowed;
        background: rgba($--base-color-black, $alpha: 0.1);
        svg {
          margin-top: 3px;
          width: 28px;
          color: rgba($--base-color-black, $alpha: 0.2);
        }
        &.active {
          cursor: pointer;
          color: rgba($--base-color-main, $alpha: 1);
          svg {
            color: rgba($--base-color-main, $alpha: 1);
          }
        }
      }
    }
  }
}
</style>
